import React from "react";
// import CountUp from 'react-countup';

import CarouselAtm from "../../atoms/carousel/CarouselAtm";
import { HomePageMembersInterface } from "../../interfaces/homePageInterfaces";
import { useFetchCollectionAPI } from "../../custom-hooks/useFetchCollectionsAPI";
import { Member } from "../../interfaces/members";

type MembersCpntProps = {
  content: HomePageMembersInterface | undefined;
};

const MembersCpnt = ({ content }: MembersCpntProps) => {
  const [isMembersCollectionLoading, membersCollection] = useFetchCollectionAPI(
      process.env.REACT_APP_API_URL + "/admin/api/collections/get/members"
    );
  let membersCollectionsSorted: Member[] = [];
  if (membersCollection) {
    membersCollectionsSorted = membersCollection.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }
    
  if (isMembersCollectionLoading) return <p>Chargement en cours...</p>;
  return (
    <article className='members-article'>
      <section className='masw-members'>
        <h2 className='maswm-title' id='members-cpnt'>
          Nos entreprises engagées
        </h2>

        {/*Wait for deployment}
                {/* <CountUp
                start={0}
                end={15}
                duration={1.5}
                suffix=" entreprises"
                />
                <CountUp
                start={0}
                end={450}
                duration={1.5}
                suffix=" salarié.es"
                /> */}
        <CarouselAtm imagesDatasArray={membersCollectionsSorted} />
      </section>
    </article>
  );
};

export default MembersCpnt;
